if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        // this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('.product-form__submit');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.submitButton?.addEventListener('click', this.onSubmitHandler.bind(this));

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        console.log("onSubmitHandler");
        evt.preventDefault();     
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.checkQtyLimit();
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            window.cart_proxy.isActive = true;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            this.setupFocusTrap();
          });
      }
      checkQtyLimit(){
        const formData = new FormData(this.form);
        const current_variant_id = formData.get('id');
        console.log(current_variant_id);
        if(window.limit_item[current_variant_id] != null){
          console.log(window.limit_item[current_variant_id]);
          const qtylimit = window.limit_item[current_variant_id];
          const cartQty = document.querySelector(`#qtylimit-${current_variant_id}`)?.getAttribute("data-cartqty");
          if(cartQty < qtylimit){
            this.submitButton.removeAttribute('disabled');
            this.submitButton.textContent(window.variantStrings.addToCart);
          }else{
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.textContent(window.variantStrings.soldOut);
          }
        }
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {  
          this.submitButton.setAttribute('disabled', 'disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.submitButtonText.textContent = window.variantStrings[text === window.variantStrings.preOrder ? 'preOrder' : 'addToCart'];
        }
      }

      // 产品页 revy-upsell-popup-block 弹窗焦点处理
      setupFocusTrap() {
        var currentPopup = null;

        const observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
              if (!(node instanceof HTMLElement)) continue;

              // 只检测新增的 popup
              if (node.id === 'revy-upsell-popup-block') {
                observer.disconnect();
                setTimeout(() => {
                  initPopup(node);
                }, 100);
                return;
              }

              // 或者 popup 在子节点里
              const popup = node.querySelector?.('#revy-upsell-popup-block');
              if (popup) {
                observer.disconnect();
                setTimeout(() => {
                  initPopup(popup);
                }, 100);
                return;
              }
            }
          }
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        // Init popup
        function initPopup(popup) {
          if (!popup) return;

          const closeBtn = popup.querySelector('.revy-upsell-popup-close-icon');

          // 必须两个都存在才初始化
          if (popup && closeBtn && popup !== currentPopup) {
            currentPopup = popup;

            // 确保 close 可聚焦
            if (!closeBtn.hasAttribute('tabindex')) {
              closeBtn.setAttribute('tabindex', '0');
              closeBtn.setAttribute('role', 'button');

              closeBtn.addEventListener('keydown', function(e) {
                if(e.key == 'Enter' || e.key == ' ') {
                  e.preventDefault(); // 若要触发空格键事件，且不触发空格导致的页面滚动默认事件
                  e.stopPropagation(); // 阻止事件冒泡

                  // 关键 - 先关闭 focus trap
                  deactivateTrap();

                  this.click();

                  // 关闭弹窗后，将焦点返回到弹窗内容区域或关闭按钮
                  const returnFocusTarget = document.querySelector('.drawer__close') || document.querySelector('.drawer__inner');
                  if (returnFocusTarget) {
                    // 优先找内部真正可点击元素
                    const innerFocusable = returnFocusTarget.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
                    (innerFocusable || returnFocusTarget)?.focus();
                  }
                }
              });
            }

            activateTrap(popup);
          }

          // 弹窗被移除
          if (!popup && currentPopup) {
            deactivateTrap();
            currentPopup = null;
          }
        }

        // 全局拦截（关键点！！）
        function handleKeydown(e) {
          if (!currentPopup) return;

          // ESC 关闭弹窗
          if (e.key === 'Escape') {
            const closeBtn = currentPopup.querySelector('.revy-upsell-popup-close-icon');
            if (closeBtn) {
              e.preventDefault();

              // 先关闭 trap
              deactivateTrap();

              // 触发关闭
              closeBtn.click();

              // 恢复焦点到 cart
              setTimeout(() => {
                const returnFocusTarget = document.querySelector('.drawer__close') || document.querySelector('.drawer__inner');
                if (returnFocusTarget) {
                  // 优先找内部真正可点击元素
                  const innerFocusable = returnFocusTarget.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
                  (innerFocusable || returnFocusTarget)?.focus();
                }
              }, 100);
                  
            }
            return;
          }

          // 原来的 Tab trap 逻辑
          if (e.key !== 'Tab') return;

          const focusable = getFocusable(currentPopup);
          if (!focusable.length) {
            e.preventDefault();
            currentPopup.focus();
            return;
          }

          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          const active = document.activeElement;

          // Shift + Tab
          if (e.shiftKey && (active === first || first.contains(active))) {
            e.preventDefault();
            last.focus();
            return;
          }

          // Tab
          if (!e.shiftKey && (active === last || last.contains(active))) {
            e.preventDefault();
            first.focus();
            return;
          }
        }

        function getFocusable(container) {
          return Array.from(container.querySelectorAll(`
            .revy-upsell-popup-close-icon,
            a[href],
            button:not([disabled]),
            textarea,
            input,
            select,
            [tabindex]:not([tabindex="-1"])
          `)).filter(el => el.offsetParent !== null);
        }

        function activateTrap(popup) {
          popup.setAttribute('tabindex', '-1');

          setTimeout(() => {
            const closeBtn = popup.querySelector('.revy-upsell-popup-close-icon');
            const focusable = getFocusable(popup);

            // 优先 focus closeBtn
            if (closeBtn) {
              closeBtn.focus();
            } else {
              (focusable[0] || popup).focus();
            }
          }, 50);

          document.addEventListener('keydown', handleKeydown, true);
          document.addEventListener('focusin', enforceFocus);
        }

        function deactivateTrap() {
          document.removeEventListener('keydown', handleKeydown, true);
          document.removeEventListener('focusin', enforceFocus);
        }

        function enforceFocus(e) {
          if (!currentPopup) return;

          if (!currentPopup.contains(e.target)) {
            const closeBtn = currentPopup.querySelector('.revy-upsell-popup-close-icon');
            (closeBtn || currentPopup).focus();
          }
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
